var map = {
	"./editorBaseApi": 88687,
	"./editorBaseApi.js": 88687,
	"./editorSimpleWorker": 26635,
	"./editorSimpleWorker.js": 26635,
	"./editorWorker": 93412,
	"./editorWorker.js": 93412,
	"./editorWorkerHost": 81978,
	"./editorWorkerHost.js": 81978,
	"./findSectionHeaders": 82743,
	"./findSectionHeaders.js": 82743,
	"./getIconClasses": 19096,
	"./getIconClasses.js": 19096,
	"./languageFeatureDebounce": 98875,
	"./languageFeatureDebounce.js": 98875,
	"./languageFeatures": 48058,
	"./languageFeatures.js": 48058,
	"./languageFeaturesService": 43033,
	"./languageFeaturesService.js": 43033,
	"./languageService": 36214,
	"./languageService.js": 36214,
	"./languagesAssociations": 21440,
	"./languagesAssociations.js": 21440,
	"./languagesRegistry": 76252,
	"./languagesRegistry.js": 76252,
	"./markerDecorations": 96490,
	"./markerDecorations.js": 96490,
	"./markerDecorationsService": 90191,
	"./markerDecorationsService.js": 90191,
	"./model": 97556,
	"./model.js": 97556,
	"./modelService": 81151,
	"./modelService.js": 81151,
	"./resolverService": 79174,
	"./resolverService.js": 79174,
	"./semanticTokensDto": 31356,
	"./semanticTokensDto.js": 31356,
	"./semanticTokensProviderStyling": 60580,
	"./semanticTokensProviderStyling.js": 60580,
	"./semanticTokensStyling": 15967,
	"./semanticTokensStyling.js": 15967,
	"./semanticTokensStylingService": 63560,
	"./semanticTokensStylingService.js": 63560,
	"./textModelSync/textModelSync.impl": 97188,
	"./textModelSync/textModelSync.impl.js": 97188,
	"./textModelSync/textModelSync.protocol": 21056,
	"./textModelSync/textModelSync.protocol.js": 21056,
	"./textResourceConfiguration": 93212,
	"./textResourceConfiguration.js": 93212,
	"./treeSitterParserService": 76556,
	"./treeSitterParserService.js": 76556,
	"./treeViewsDnd": 56079,
	"./treeViewsDnd.js": 56079,
	"./treeViewsDndService": 21272,
	"./treeViewsDndService.js": 21272,
	"./unicodeTextModelHighlighter": 29641,
	"./unicodeTextModelHighlighter.js": 29641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25834;